import ForgetModal from "./auth-components/forget-password/ForgetModal";
import LoginModal from "./auth-components/login-modal/LoginModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import Register from "./auth-components/register/Register";
import UserStatusModal from "./auth-components/user-status/UserStatusModal";
import MessageModal from "./message-modal/MessageModal";
import OtpModal from "./auth-components/otp-modal/OtpModal";
import ChangePassword from "./auth-components/change-password/ChangePassword";

const LoginComponents = () => {
  const isRegister = useSelector((state: RootState) => state.user.isRegister);
  const isLogin = useSelector((state: RootState) => state.user.isLogin);
  const isUserStatus = useSelector(
    (state: RootState) => state.user.isUserStatus
  );
  const isForgetPassword = useSelector(
    (state: RootState) => state.user.isForgetPassword
  );
  const isMessage = useSelector(
    (state: RootState) => state.user.isMessage
  );
  const isOtp = useSelector(
    (state: RootState) => state.user.isOtp
  );
  const isChangePassword=useSelector(
    (state:RootState)=>state.user.isChangePassword
  )

  return (
    <>
      {isLogin && <LoginModal />}
      {isForgetPassword && <ForgetModal />}
      {isRegister && <Register />}
      {isUserStatus && <UserStatusModal />}
      {isMessage && <MessageModal />}
      {isOtp && <OtpModal />}
      {isChangePassword && <ChangePassword/>}
    </>
  );
};

export default LoginComponents;
